let productCardSwatchGroupCounter = 0;

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.TRANSITION_DURATION = 0;
    this.isNavigating = false;
    this.image = this.querySelector('img.product-card__image');
    this.priceRegular = this.querySelector('.price-item--regular');
    this.priceCompare = this.querySelector('.price-item--compare');
    this.priceContainer = this.querySelector('.product-price');
    this.productLink = this.querySelector('a[href]');
    this.swatches = Array.from(
      this.querySelectorAll('input[type="radio"][name^="Color-"]'),
    );
    this.quickViewTrigger = this.querySelector('.js-quick-view-trigger');

    if (this.swatches.length > 0) {
      this.ensureUniqueSwatchGroup();
      this.initSwatches();
    }

    this.initNavigationStateReset();
    this.initNavigationTransition();
  }

  initSwatches() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener('change', this.onSwatchChange.bind(this));
    });
  }

  ensureUniqueSwatchGroup() {
    const uniqueKey =
      this.dataset.swatchGroupId || `pc-${productCardSwatchGroupCounter++}`;
    this.dataset.swatchGroupId = uniqueKey;

    const baseName = this.swatches[0].name || 'Color-product';
    const uniqueName = `${baseName}-${uniqueKey}`;

    this.swatches.forEach((swatch) => {
      swatch.name = uniqueName;
    });

    if (!this.swatches.some((swatch) => swatch.checked)) {
      this.swatches[0].checked = true;
    }
  }

  onSwatchChange(event) {
    const target = event.target;
    const variantImage = target.dataset.variantImage;
    const variantPrice = target.dataset.variantPrice;
    const variantCompareAtPrice = target.dataset.variantCompareAtPrice;
    const variantId = target.dataset.variantId;

    if (variantId && this.quickViewTrigger) {
      this.quickViewTrigger.dataset.variantId = variantId;
    }

    if (variantImage && this.image) {
      this.image.src = variantImage;
      this.image.srcset = variantImage;
    }

    if (variantPrice && this.priceRegular) {
      this.priceRegular.innerHTML = variantPrice;

      if (variantCompareAtPrice) {
        if (this.priceCompare) {
          this.priceCompare.innerHTML = variantCompareAtPrice;
          this.priceCompare.style.display = 'inline-block';
        } else if (this.priceContainer) {
          // Create compare at price element if it doesn't exist but is needed
          const compareEl = document.createElement('span');
          compareEl.className =
            'price-item price-item--compare body-base text-color-text-muted line-through';
          compareEl.innerHTML = variantCompareAtPrice;
          this.priceContainer.appendChild(compareEl);
          this.priceCompare = compareEl;
        }
      } else if (this.priceCompare) {
        // Hide compare at price if variant doesn't have one
        this.priceCompare.style.display = 'none';
      }
    }
  }

  initNavigationTransition() {
    if (!this.productLink) return;

    this.productLink.addEventListener(
      'click',
      this.onProductLinkClick.bind(this),
    );
  }

  onProductLinkClick(event) {
    if (this.isNavigating) {
      event.preventDefault();
      return;
    }

    window.LenszaAnalytics?.publish(
      'product_selected',
      {
        item_list_id: this.dataset.analyticsItemListId || 'unspecified',
        item_list_name: this.dataset.analyticsItemListName || 'unspecified',
        items: [
          {
            item_id: this.dataset.analyticsProductId || undefined,
            item_name: this.dataset.analyticsProductName || undefined,
            item_brand: this.dataset.analyticsProductBrand || undefined,
          },
        ],
      },
      { gaEventName: 'select_item' },
    );

    const transitionApi = window.PdpNavigationTransition;
    if (!transitionApi || !this.productLink || !this.image) {
      document.dispatchEvent(
        new CustomEvent('product-card:navigate', { bubbles: false }),
      );
      return;
    }

    const started = transitionApi.start({
      event,
      link: this.productLink,
      image: this.image,
      duration: this.TRANSITION_DURATION,
    });

    if (started) {
      this.isNavigating = true;
    }

    document.dispatchEvent(
      new CustomEvent('product-card:navigate', { bubbles: false }),
    );
  }

  initNavigationStateReset() {
    if (window.__pdpNavTransitionStateResetBound) return;

    const reset = () => {
      document.querySelectorAll('product-card').forEach((card) => {
        if (card && typeof card.isNavigating !== 'undefined') {
          card.isNavigating = false;
        }
      });
    };

    window.addEventListener('pageshow', reset);
    window.__pdpNavTransitionStateResetBound = true;
  }
}

customElements.define('product-card', ProductCard);
